var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_pending",
    "data-name": "calendar pending",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_5",
    "data-name": "\\uD0C0\\uC6D0 5",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1 1)",
    fill: "#33d9b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_292",
    "data-name": "\\uADF8\\uB8F9 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_210",
    "data-name": "\\uD328\\uC2A4 210",
    d: "M18.23,7.233H13.3a.634.634,0,1,0,0,1.267h4.93a.634.634,0,0,0,0-1.267Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_211",
    "data-name": "\\uD328\\uC2A4 211",
    d: "M10.815,6.633V9.1a.634.634,0,1,0,1.267,0V6.633a.634.634,0,1,0-1.267,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_212",
    "data-name": "\\uD328\\uC2A4 212",
    d: "M19.446,6.633V9.1a.634.634,0,0,0,1.267,0V6.633a.634.634,0,1,0-1.267,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_213",
    "data-name": "\\uD328\\uC2A4 213",
    d: "M7.767,12.2H18.846a.634.634,0,0,0,0-1.267H7.767V9.1a.6.6,0,0,1,.6-.6H9.6a.633.633,0,1,0,0-1.267H8.366A1.868,1.868,0,0,0,6.5,9.1V22.662a1.866,1.866,0,0,0,1.866,1.866h8.313a.634.634,0,0,0,0-1.267H8.366a.6.6,0,0,1-.6-.6Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_214",
    "data-name": "\\uD328\\uC2A4 214",
    d: "M23.761,10.932H21.312a.634.634,0,0,0,0,1.267h2.449v3.87a.634.634,0,1,0,1.267,0V9.1a1.866,1.866,0,0,0-1.866-1.866H21.929a.634.634,0,0,0,0,1.267h1.233a.6.6,0,0,1,.6.6Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_6",
    "data-name": "\\uD0C0\\uC6D0 6",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(10.572 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_7",
    "data-name": "\\uD0C0\\uC6D0 7",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(10.572 16.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_8",
    "data-name": "\\uD0C0\\uC6D0 8",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(10.572 19.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9",
    "data-name": "\\uD0C0\\uC6D0 9",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(13.625 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_10",
    "data-name": "\\uD0C0\\uC6D0 10",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(13.625 16.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_11",
    "data-name": "\\uD0C0\\uC6D0 11",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(13.625 19.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_12",
    "data-name": "\\uD0C0\\uC6D0 12",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(16.679 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_13",
    "data-name": "\\uD0C0\\uC6D0 13",
    cx: 0.848,
    cy: 0.848,
    r: 0.848,
    transform: "translate(19.732 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_215",
    "data-name": "\\uD328\\uC2A4 215",
    d: "M21.451,18.169a2.782,2.782,0,1,1-2.782,2.782,2.782,2.782,0,0,1,2.782-2.782Zm0-1.267A4.049,4.049,0,1,0,25.5,20.951,4.049,4.049,0,0,0,21.451,16.9Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_216",
    "data-name": "\\uD328\\uC2A4 216",
    d: "M20.818,19.243v1.708A.637.637,0,0,0,21,21.4l1.139,1.139a.636.636,0,0,0,.9-.9l-.953-.953V19.243a.634.634,0,0,0-1.267,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpected);
export default __webpack_public_path__ + "static/media/expected.e7507348d518187c4ffaec4df3499260.svg";
export { ForwardRef as ReactComponent };